import axios from "axios";
import apiConfig from "@/config/api.config";
import {
  requestInterceptor,
  responseInterceptor,
} from "../http/api-interceptors.js";

/**
 * Creates an instance of the axios which will be used to consume admin resources
 * throughout the application
 */
export const $admin = axios.create({
  baseURL: apiConfig.ADMIN_API_BASE_URL,
});

/**
 * Intercepts all the api requests
 */
$admin.interceptors.request.use(requestInterceptor);

/**
 * Intercepts api response
 * @todo Integerate the response interceptors
 */
$admin.interceptors.response.use(undefined, responseInterceptor);
